import { render, staticRenderFns } from "./ResultPagination.vue?vue&type=template&id=44bed1b2&scoped=true&"
import script from "./ResultPagination.vue?vue&type=script&lang=js&"
export * from "./ResultPagination.vue?vue&type=script&lang=js&"
import style0 from "./ResultPagination.vue?vue&type=style&index=0&id=44bed1b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bed1b2",
  null
  
)

export default component.exports